import { RESET_PASSWORD_API } from '@constants/api';
import _axios from '@plugins/_axios';

/**
 * 重置密码
 * @param {String} cellphone 手机号
 * @param {String} password 密码
 * @param {String} code 手机验证码
 * @param {Number} role 角色
 */
export function resetPassword({ cellphone, password, code, role = 1 }) {
    return _axios.post(RESET_PASSWORD_API, {
        cellphone,
        password,
        code,
        role
    });
}
